<!DOCTYPE html>
<div class="modal-wrapper">
  <h1> <img src="../../../assets/icon/imog-icon.png" alt=""></h1>
  <h2 class="heading">Great!</h2>
  <h6 class="sub-heading">
    You can now help to contribute...
  </h6>
  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam nisi metus, ornare a vestibulum eget, gravida
    vitae velit. </p>
  <ion-row>
    <ion-button expand="block" color="medium" class="capsule-btn " (click)="close()" type="submit">Close</ion-button>
  </ion-row>
</div>